var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGruppe25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204,
    height: 204,
    viewBox: "0 0 204 204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bfbfbf;}.b{fill:#fff;}.c{fill:#eee;}.d{fill:none;stroke:#bfbfbf;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1512 -296)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,51.575,22.866,14.087A19.324,19.324,0,0,1,39.558,4.5H160.324a7.247,7.247,0,0,1,6.26,10.9L144.716,52.886a19.324,19.324,0,0,1-16.692,9.587H7.257A7.246,7.246,0,0,1,1,51.575Zm127.026,20.56H28.987V86.629A14.493,14.493,0,0,0,43.48,101.122H91.791l19.324,19.324h48.311a14.493,14.493,0,0,0,14.493-14.493V22L153.062,57.754A29.085,29.085,0,0,1,128.024,72.135Z",
    transform: "translate(1501 240.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.868,11.96l3.626,2.189-.962-4.125,3.2-2.775L10.517,6.89,8.868,3,7.219,6.89,3,7.248l3.2,2.775-.962,4.125Z",
    transform: "translate(1653.132 338.676)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 31,
    height: 5,
    transform: "translate(1618 346)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 102,
    cy: 7,
    rx: 102,
    ry: 7,
    transform: "translate(1486 435)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.126,38.313l14.292,8.626L36.625,30.682,49.252,19.743,32.624,18.332,26.126,3l-6.5,15.332L3,19.743,15.627,30.682,11.834,46.939Z",
    transform: "translate(1572.893 467.551) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.534,17.558l5.892,3.556-1.564-6.7L22.068,9.9l-6.855-.582L12.534,3,9.855,9.321,3,9.9l5.206,4.51-1.564,6.7Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 1535.875, 423.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.469,26.621l9.56,5.77L25.492,21.516,33.938,14.2l-11.122-.944L18.469,3,14.122,13.256,3,14.2l8.446,7.317L8.909,32.391Z",
    transform: "translate(1640.495 444.526) rotate(-31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3490.043,314.54a11.214,11.214,0,0,1-5.968,11.381",
    transform: "matrix(0.53, 0.848, -0.848, 0.53, -19.513, -2683.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3489.124,319.342a10.139,10.139,0,0,1-5.049,6.579",
    transform: "translate(1262.514 -3043.974) rotate(80)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGruppe25);
export default __webpack_public_path__ + "static/media/Gruppe 25.63d46d8849d9c60a1271ef5d84335e94.svg";
export { ForwardRef as ReactComponent };